<!--header refactor here-->
<header role="banner" class="container-fluid ">
  @if(!!currentRoute
  && !currentRoute.includes('/page/')
  && !existsSessionUser) {
  <div class="row ml-4 mr-4 mt-4 mb-2 align-items-center">
    <div class="col-md-2 offset-md-1 col-12 text-center text-md-left mb-3 mb-md-0">
      <img
        id="logo"
        [src]="this.safeLogoSource"
        alt="logo"
        style="max-height: var(--logo-height, 50px)"
      >
    </div>
    <div class="col-md-9 col-12 text-center text-md-left">
      <h3 class="overflowtext mb-0">{{'APPLICATION.SFK-ONLINE'|translate}} - {{'APPLICATION.SFK-MODUL'|translate}}</h3>
    </div>
  </div>
  }
  @if(!!currentRoute && !currentRoute.includes('/authentication/')
  && !currentRoute.includes('/information/')
  && existsSessionUser) {
  <section   >
    <app-navbar-responsive
      [moduleEnabled]="moduleEnabled"
      [roleEnabled]="roleEnabled"
      [benutzer]="benutzer"
      [millisecUntilLogout$]="millisecUntilLogout$"
      [endDateForLogout$]="endDateForLogout$"
      [loggedoutMessageVisible$]="loggedoutMessageVisible$"
    ></app-navbar-responsive>
  </section>
  }
</header>

<div class="container" >
  <router-outlet></router-outlet>
</div>

<app-footer-custom></app-footer-custom>

<ngx-spinner  [color]="'var(--spinner-color)'"
              [bdColor]="'var(--spinner-bd-color)'"
              size="medium"
              type="ball-scale-multiple"
              [fullScreen] = "true"
              [showSpinner]="loading"
>
</ngx-spinner>
